import React from "react";

export const LogoDark: React.FC = () => (
    <svg
    width="36"
    height="33"
    viewBox="0 0 103 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M70.8,8H32.9c-12.7,0-23,10.3-23,23v38c0,12.7,10.3,23,23,23h37.9c12.7,0,23-10.3,23-23V31
	C93.8,18.3,83.5,8,70.8,8z M77.6,66.9c-0.5,2.3-1.4,4.4-2.6,6.4c-1,1.6-2.4,2.9-4.1,3.8c-1.9,0.9-3.9,1.3-6,1.1
	c-2.8-0.1-5.6-0.6-8.3-1.4l-20.1-5.4c-2.8-0.7-5.5-1.7-8-3c-1.8-0.9-3.4-2.3-4.6-4c-1-1.6-1.6-3.4-1.6-5.3c0-2.3,0.3-4.7,0.9-6.9
	l6.7-24.8l9.2,6.9l-4.9,18.2c-0.4,1.3-0.6,2.6-0.7,3.9c-0.1,0.9,0.1,1.9,0.4,2.7c0.4,0.8,1.1,1.5,1.9,1.9c1.2,0.6,2.4,1.1,3.7,1.4
	l18.5,5c1.3,0.4,2.6,0.6,4,0.7c1,0,1.9-0.2,2.8-0.7c0.8-0.5,1.5-1.2,1.9-2.1c0.6-1.2,1.1-2.4,1.4-3.7l6-22.5l9.2,6.8L77.6,66.9z" fill="#99CC58"/>
  </svg>
);

LogoDark.displayName = "LogoDark";
